import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { netdiskFiles } from '@/mocks/home';
import SectionHeading from './SectionHeading';

interface NetdiskNavProps {
  notify: (msg: string) => void;
}

export default function NetdiskNav({ notify }: NetdiskNavProps) {
  const [revealed, setRevealed] = useState<string[]>([]);

  const toggleCode = (id: string) => {
    setRevealed((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <SectionHeading
            kicker="网盘文件"
            icon="ri-cloud-line"
            title="网盘文件导航 · 提取码可查"
            desc="百度、夸克、阿里、迅雷多平台分流，体积与更新时间一目了然，提取码点击即显，找不到文件时也能快速补档。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <div className="hidden grid-cols-12 gap-3 border-b border-background-200 bg-background-100 px-5 py-3 text-xs font-medium text-foreground-500 md:grid">
              <span className="col-span-5">文件名</span>
              <span className="col-span-2">网盘平台</span>
              <span className="col-span-1">体积</span>
              <span className="col-span-2">提取码</span>
              <span className="col-span-2 text-right">操作</span>
            </div>
            <ul className="divide-y divide-background-200">
              {netdiskFiles.map((file) => {
                const shown = revealed.includes(file.id);
                return (
                  <li key={file.id} className="flex flex-col gap-3 px-4 py-4 md:grid md:grid-cols-12 md:items-center md:gap-3 md:px-5">
                    <div className="flex min-w-0 items-center gap-3 md:col-span-5">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                        <i className="ri-file-zip-line text-lg"></i>
                      </span>
                      <span className="min-w-0">
                        <span className="block truncate text-sm text-foreground-900">{file.name}</span>
                        <span className="text-[11px] text-foreground-400">更新于 {file.time}</span>
                      </span>
                    </div>

                    <div className="flex flex-wrap items-center gap-2 md:col-span-2">
                      <span className={`rounded-sm px-2 py-0.5 text-[11px] ${file.platformClass}`}>{file.platform}</span>
                    </div>

                    <div className="text-xs text-foreground-600 md:col-span-1">{file.size}</div>

                    <div className="flex items-center gap-2 md:col-span-2">
                      <span className="font-mono text-sm tracking-widest text-foreground-800">
                        {shown ? file.code : '••••'}
                      </span>
                      <button
                        type="button"
                        onClick={() => toggleCode(file.id)}
                        className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs text-primary-600 transition-colors hover:text-primary-700"
                      >
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className={shown ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                        </span>
                        {shown ? '隐藏' : '显示'}
                      </button>
                    </div>

                    <div className="flex flex-wrap items-center gap-2 md:col-span-2 md:justify-end">
                      <button
                        type="button"
                        onClick={() => notify(`已复制「${file.name}」的分享链接`)}
                        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                      >
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-link"></i>
                        </span>
                        复制链接
                      </button>
                      <button
                        type="button"
                        onClick={() => notify(`正在跳转 ${file.platform} 取件页`)}
                        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-secondary-600 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-secondary-700"
                      >
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-external-link-line"></i>
                        </span>
                        打开
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}